import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DragAndDropFileComponent} from "./drag-and-drop-file.component";
import {DragAndDropFileDirective} from "./directives/drog-and-drop-file.directive";

@NgModule({
  declarations: [DragAndDropFileDirective, DragAndDropFileComponent],
  imports: [CommonModule],
  exports: [DragAndDropFileComponent],
})
export class DragAndDropFileModule {}
